<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import { usePoolsStore } from '@/stores/pools';
import { fetchPoolBets } from '@/api/admin-be';
import { catchError } from '@/helpers/toast';
import BetsList from '@/components/pools/pool-bets/bets-list.vue';
import Pagination from '@/components/pagination.vue';

export default defineComponent({
  name: 'pool-bets',
  components: { Pagination, BetsList },
  computed: {
    ...mapState(usePoolsStore, ['currentPoolId']),
  },
  data() {
    return {
      loading: false,

      betsOffset: 0,
      betsPageSize: 20,
      betsCount: 0,
      bets: null,
    };
  },
  methods: {
    fetchBets() {
      this.loading = true;
      if (this.currentPoolId) {
        fetchPoolBets(this.currentPoolId, {
          offset: this.betsOffset,
          count: this.betsPageSize,
        })
          .then((res) => {
            this.betsCount = res.count;
            this.bets = res.bets;
          })
          .catch((error) => catchError('Ошибка добавления маркета', error))
          .finally(() => (this.loading = false));
      }
    },
    flipBetsPage(newOffset: number) {
      this.betsOffset = newOffset;
      this.fetchBets();
    },
    resizeBetsPage(newSize: number) {
      this.betsPageSize = newSize;
      this.fetchBets();
    },
  },
  mounted() {
    this.fetchBets();
  },
});
</script>

<template>
  <template v-if="!currentPoolId">
    <div class="text-lg italic text-gray-400 dark:text-gray-600 my-2">
      Выберите пул в списке пулов для просмотра ставок
    </div>
  </template>
  <template v-else>
    <bets-list :bets="bets" :pageSize="betsPageSize" />
    <div class="text-center">
      <Pagination
        :offset="betsOffset"
        :size="betsPageSize"
        :count="betsCount"
        :resizable="true"
        @flip="flipBetsPage"
        @resize="resizeBetsPage"
      />
    </div>
  </template>
</template>

<style scoped lang="scss"></style>